var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelevoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 189 45",
    style: {
      enableBackground: "new 0 0 189 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fcb301;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.3,16.8c0-9.3-7.2-15.1-17.8-15.1h-9.8l-7.2,9.5l16.7,0c4.1,0,7.4,2.2,7.4,5.7c0,3.5-3.3,5.8-7.4,5.8 l-18.4,0v-9.2l-5.4,7.1L0,27.6l5.4,7.1l5.4,7.1v-9.6H24v0h4l9.2,12.5h12.9L39.1,30.2C44.2,27.7,47.4,22.5,47.3,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.5,13.3c-9.6,0-16,6.6-16,15.7c0,9.2,6.6,15.8,16.5,15.8c7.5,0,13.2-3.9,14.7-10.1h-9.9 c-1,1.5-2.8,2.3-4.6,2.2c-3.1,0.2-6-1.8-6.8-4.8h21.5l-0.1-0.2c0.2-1.1,0.2-2.3,0.2-3.4l0,0C78.9,19.3,72.3,13.3,63.5,13.3z  M57.2,26.1c0.6-3,3.3-5.2,6.3-5c3-0.2,5.7,2,6,5H57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92,0H81.9v44.1H92v-1.3c0,0,0,0,0,0L92,0L92,0L92,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.2,13.3c-9.6,0-16,6.6-16,15.7c0,9.2,6.6,15.8,16.5,15.8c7.5,0,13.2-3.9,14.7-10.1h-9.9 c-1,1.5-2.8,2.3-4.6,2.2c-3.9,0-6-2.1-6.8-4.8h21.5l-0.1-0.2c0.2-1.1,0.2-2.3,0.2-3.4l0,0C125.7,19.3,119,13.3,110.2,13.3z  M103.9,26.1c0.6-3,3.3-5.2,6.3-5c3-0.2,5.7,2,6,5H103.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "148.6,14 141.3,31.4 134.1,14 123.5,14 136.6,44.1 146.1,44.1 159.2,14  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.6,13.3c-9.5,0-16.3,6.6-16.3,15.7c0,9.2,6.8,16,16.3,16c9.5,0,16.3-6.8,16.3-16 C189,19.9,182.1,13.3,172.6,13.3z M179.5,29.1c0,4-2.7,7.3-6.8,7.3c-4.1,0-6.8-3.2-6.8-7.3c-0.2-3.7,2.7-6.9,6.4-7.1 c0.1,0,0.3,0,0.4,0c3.7,0,6.8,3,6.8,6.7C179.5,28.8,179.5,28.9,179.5,29.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelevoLogo);
export default __webpack_public_path__ + "static/media/relevo_logo.47ff592834ced65678d114cd2308d1ea.svg";
export { ForwardRef as ReactComponent };